"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Serializer_1 = require("./Serializer");
const types_1 = require("../schema/types");
const result_1 = require("../result");
class FieldInfo {
    constructor(name, serializer, description, isOptional, defaultValue) {
        this.name = name;
        this.serializer = serializer;
        this.description = description;
        this.isOptional = isOptional;
        this.defaultValue = defaultValue;
    }
    get T() {
        throw new Error("Not meant to be accessed at runtime!");
    }
    withName(newName) {
        return new FieldInfo(newName, this.serializer, this.description, this.isOptional, this.defaultValue);
    }
}
exports.FieldInfo = FieldInfo;
class ObjectSerializer extends Serializer_1.BaseSerializer {
    constructor(properties) {
        super();
        this.properties = properties;
    }
    get TValue() {
        throw new Error("only for compiletime");
    }
    canSerialize(value) {
        if (typeof value !== "object" || value === null) {
            return false;
        }
        // does it have all required fields?
        for (const [fieldName, field] of Object.entries(this.properties)) {
            if (!(fieldName in value)) {
                if (!field.isOptional) {
                    return false;
                }
            }
        }
        // do the required fields match?
        for (const [fieldName, field] of Object.entries(this.properties)) {
            if (fieldName in value) {
                const fieldVal = value[fieldName];
                if (!field.serializer.canSerialize(fieldVal)) {
                    return false;
                }
            }
        }
        return true;
    }
    deserializeWithContext(value, context) {
        if (typeof value !== "object" || value === null) {
            return result_1.deserializationError({
                message: `Expected an object, but got ${typeof value}.`,
            });
        }
        const errors = new Array();
        const result = {};
        for (const [fieldName, field] of Object.entries(this.properties)) {
            if (!(fieldName in value)) {
                if (!field.isOptional) {
                    errors.push(new result_1.DeserializationError({
                        message: `Required field ${fieldName} is missing.`,
                    }));
                }
                else if (field.defaultValue) {
                    //debugger;
                    result[fieldName] = field.defaultValue.value;
                }
            }
            else {
                const fieldVal = value[fieldName];
                const newFieldVal = field.serializer.deserializeWithContext(fieldVal, context);
                if (!newFieldVal.isOk) {
                    errors.push(...newFieldVal.errors.map(e => e.prependPath(fieldName)));
                }
                else {
                    result[fieldName] = newFieldVal.value;
                }
            }
        }
        for (const [propName, fieldVal] of Object.entries(value)) {
            /*if (fieldName === "$ns" || fieldName === "$type") {
                // the parent handles these fields.
                continue;
            }*/
            const field = this.properties[propName];
            if (!field) {
                errors.push(new result_1.DeserializationError({
                    message: `Did not expect field ${propName}.`,
                }));
            }
        }
        if (errors.length > 0) {
            return result_1.deserializationError(...errors);
        }
        return result_1.deserializationValue(result);
    }
    serializeWithContext(value, context) {
        const result = {};
        for (const [fieldName, field] of Object.entries(this.properties)) {
            if (fieldName in value) {
                const v = value[fieldName];
                const val = field.serializer.serializeWithContext(v, context);
                result[fieldName] = val;
            }
            else {
            }
        }
        return result;
    }
    getType(typeSystem) {
        return new types_1.ObjectType(Object.fromEntries(Object.entries(this.properties).map(([key, val]) => [
            key,
            new types_1.ObjectProperty(key, val.serializer.getType(typeSystem), val.isOptional, val.defaultValue),
        ])));
    }
}
exports.ObjectSerializer = ObjectSerializer;
function sObject(data) {
    const normalizedFields = normalizeProperties(data.properties);
    return new ObjectSerializer(normalizedFields);
}
exports.sObject = sObject;
function normalizeProperties(fields) {
    const normalizedFields = {};
    for (const [name, val] of Object.entries(fields)) {
        if ("serialize" in val) {
            normalizedFields[name] = new FieldInfo(name, val, undefined, false, undefined);
        }
        else if (val instanceof FieldInfo) {
            if (!val) {
                console.log(fields);
            }
            normalizedFields[name] = val.withName(name);
        }
        else {
            throw new Error(`Unexpected field type: ${val}`);
        }
    }
    return normalizedFields;
}
exports.normalizeProperties = normalizeProperties;
function field(options) {
    let defaultVal = undefined;
    if (typeof options.optional === "object" &&
        "withDefault" in options.optional) {
        defaultVal = { value: options.optional.withDefault };
    }
    return new FieldInfo("(not set yet)", options.serializer, options.description, !!options.optional, defaultVal);
}
exports.field = field;
//# sourceMappingURL=ObjectSerializer.js.map